import React from 'react';
import { Divider } from 'rsuite';
import {setInstallmentText, findLastUnpaidCashflow}  from '../../../../../app/common/services/vehicle.service';
import {BackIcon} from '../../svg/iconsSvg';
import CardPayment from '../elements/CardPayment';

const PayInstWithCard = ({onBack, onForward, policy, style}) => {

    const unpaidCashFlow = findLastUnpaidCashflow(policy?.cashflows);
    const insuranceId = policy?.insuranceId;
    const cashflowId = unpaidCashFlow?.cashflowId;

    let payAmount =  Number.parseFloat(unpaidCashFlow?.dueAmount).toFixed(2);
    payAmount = Number.isNaN(parseInt(payAmount)) ? null : payAmount;

    let payAmountEUR =  Number.parseFloat(unpaidCashFlow?.dueAmountEUR).toFixed(2);
    payAmountEUR = Number.isNaN(parseInt(payAmountEUR)) ? null : payAmountEUR;


    const goBack = () => {
        onBack(4)
    }

    const goForward = () => {
        onForward(6);
    }

    return (
        <div className="steps_container" style={style}>
            <div  className="head">
                <div className="head-icon" style={{paddingLeft: '2rem'}} onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>{setInstallmentText(unpaidCashFlow)}</h6>
            </div>
            <Divider style={{marginBottom: 0 , backgroundColor: '#6bdfa7', height: '.5px'}}/>

            <CardPayment insuranceId={insuranceId} cashflowId={cashflowId} payAmount={payAmount} payAmountEUR={payAmountEUR} onForward={goForward} />
        </div>
    );
}

export default PayInstWithCard;

//<CirclePlusIcon size={22} />